import React from 'react';
import './ConfirmLink.scss';

interface Props {
  title: string;
  confirmTitle: string;
  onPress: (e: any) => void;
  className?: string;

  noConfirm?: boolean;
  style?: any;
  disabled?: boolean;
}
const ConfirmLink: React.FC<Props> = (props) => {
  const press = (e: any) => {
    if (!props.noConfirm) {
      const confirm = window.confirm(props.confirmTitle)
      if (!confirm)
        return;
    }
    props.onPress(e)
  }
  return (
    <div
      className={[props.className || ''].join(' ')}
      style={{ cursor: 'pointer', ...(props.style || {})}}
      onClick={props.disabled ? undefined : press}
      >
      {props.title}
    </div>
  );
}

export default ConfirmLink;
